import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const taskInheritedDetail = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Task/TaskInheritedDetail",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getInheritedTask = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Task/GetInherited",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postInheritedTask = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Task/PostInherited",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const taskInfo = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "task/info",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const taskPreShare = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "task/PreShare",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const moveTaskToColumn = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Task/moveTaskToColumn",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getSharedTaskProjects = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "task/GetSharedTaskProjects",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getDataWDL = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "task/getDataWDL",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getDataWDI = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "task/getDataWDI",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const boxInTaskList = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "task/BoxInTaskList",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
